import { FC } from 'react';
import { ProductDescModalViewType } from '../../types/view/ProductDescModalViewType';
import { CommonModal } from '../CommonModal';
import { ImageSlider } from '../ModalItem/ImageSlider';
import '../../assets/css/productDesc.css';
import styles from '../../assets/scss/ProductDescModal/ProductDescModal.module.scss';
import { ProductAccordion } from './ProductAccordion';
import { BottomButton } from '../ModalItem/BottomButton';

export const ProductDescModal: FC<{
  active: boolean;
  closeFunc: () => void;
  productDescModal: ProductDescModalViewType | null;
}> = ({ active, closeFunc, productDescModal }) => {
  if (!productDescModal) return <></>;

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      <div className={styles.container}>
        {/* 商品スライダー */}
        <ImageSlider images={productDescModal.images} />

        {/* 商品タイトル */}
        <p className={styles.title}>{productDescModal.title}</p>

        {/* セット内容 */}
        {productDescModal.setItems && (
          <div className={styles.productSetContainer}>
            <p className={styles.productSetTitle}>セット内容</p>
            <div
              className={styles.productSetMenu}
              dangerouslySetInnerHTML={{
                // タグとタグの間のものをすべて削除
                __html: productDescModal.setItems.replace(/>[\s\u3000]*</g, '><'),
              }}
            />
          </div>
        )}

        {productDescModal.pageInfo.length > 1 ? (
          /* セット用のアコーディオン */
          <div className={styles.ingredientsAccordionContainer}>
            <div className={styles.ingredientsAccordion}>
              {productDescModal.pageInfo.map((page, index) => (
                <ProductAccordion
                  key={index}
                  title={page.title}
                  image={page.image}
                >
                  <div
                    className="product-new-ingredients__body"
                    dangerouslySetInnerHTML={{
                      __html: page.body,
                    }}
                  />
                </ProductAccordion>
              ))}
            </div>
          </div>
        ) : (
          /* 単品用のアコーディオン */
          <div className={styles.ingredientsContainer}>
            <div
              className="product-new-ingredients__body"
              dangerouslySetInnerHTML={{
                __html: productDescModal.pageInfo[0].body,
              }}
            />
          </div>
        )}

        {/* 閉じるボタン */}
        <div className={styles.btnContainer}>
          <BottomButton
            buttonTitle="閉じる"
            clickFunc={closeFunc}
          />
        </div>
      </div>
    </CommonModal>
  );
};
